import type {RepositoryDataResponse} from '@github-ui/data-router-error-helpers'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {Query} from '@github-ui/react-query'
import {RepositoryMilestoneIndexPageQuery} from '@github-ui/server-persisted-queries'
import type {RepositoryMilestoneIndexPageQueryQuery} from '@github-ui/server-persisted-queries/types/RepositoryMilestoneIndexPageQuery'

import {repoAppBuilder} from '@github-ui/repo-app-builder'

export type MilestoneIndexPayload = RepositoryDataResponse<RepositoryMilestoneIndexPageQueryQuery>

export function buildMilestoneIndexRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('milestonesRoute', {
    path: '/:owner/:repo/milestones',
    queries: [
      mainQuery<MilestoneIndexPayload>({
        queryDeps: ({pathname, searchParams}) => {
          const sort = searchParams.get('sort')
          const direction = searchParams.get('direction')
          return {
            pathname,
            searchParams: {
              queryId: RepositoryMilestoneIndexPageQuery,
              state: searchParams.get('state') || 'open',
              page: searchParams.get('page') || '1',
              ...(sort && direction ? {sort, direction} : {}),
            },
          }
        },
      }),
    ],
  })
}

export const milestoneIndexRoute = buildMilestoneIndexRoute(repoAppBuilder)

export function isRepositoryMilestoneIndexQuery(query: Query, pathname: string): boolean {
  const prefix = milestoneIndexRoute.queries.mainQuery.makeQueryKey().slice(0, -1)
  const key = query.queryKey
  if (key.length !== prefix.length + 1 || !prefix.every((segment, index) => key[index] === segment)) return false
  const dependencies = key[prefix.length]
  return (
    typeof dependencies === 'object' &&
    dependencies !== null &&
    'pathname' in dependencies &&
    dependencies.pathname === pathname
  )
}
